import React, { useState, useEffect } from 'react';

import { emit, onElectronEvent } from 'services/electron-service';

import './WindowsAppControls.styles.css';

const WindowsAppControls = () => {
    const [maximized, setMaximized] = useState(false);
    const handleMinimizeClick = () => {
        emit('windowControlClick', 'minimize');
    }
    const handleUnmaximizeClick = () => {
        emit('windowControlClick', 'unmaximize');
    }
    const handleMaximizeClick = () => {
        emit('windowControlClick', 'maximize');
    }
    const handleCloseClick = () => {
        emit('windowControlClick', 'close');
    }

    useEffect(() => {
        onElectronEvent('unmaximize', () => {
            setMaximized(false);
        });

        onElectronEvent('maximize', () => {
            setMaximized(true);
        })

        emit('getMaximizedState');
    }, []);

    return (
        <div className="windows-app-controls">
            <button onClick={handleMinimizeClick} title="Minimize" className="windows-app-controls-button" tabIndex="-1">
                <svg width="10" height="1" viewBox="0 0 10 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 -0.000976562V1H0V-0.000976562H10Z"></path>
                </svg>
            </button>

            {
                maximized ? (
                    <button onClick={handleUnmaximizeClick} title="Unmaximize" className="windows-app-controls-button" tabIndex="-1">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 7.99805H7.99805V10H0V2.00195H2.00195V0H10V7.99805ZM7.00195 2.99805H1.00098V8.99902H7.00195V2.99805ZM8.99902 1.00098H2.99805V2.00195H7.99805V7.00195H8.99902V1.00098Z"></path>
                        </svg>
                    </button>
                ) : (
                    <button onClick={handleMaximizeClick} title="Maximize" className="windows-app-controls-button" tabIndex="-1">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0H10V10H0V0ZM9.375 9.375V0.625H0.625V9.375H9.375Z"></path>
                        </svg>
                    </button>
                )
            }

            <button onClick={handleCloseClick} title="Close" className="windows-app-controls-button windows-app-controls-close" tabIndex="-1">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.44434 5L9.90723 9.46777L9.46777 9.90723L5 5.44434L0.532227 9.90723L0.0927734 9.46777L4.55566 5L0.0927734 0.532227L0.532227 0.0927734L5 4.55566L9.46777 0.0927734L9.90723 0.532227L5.44434 5Z"></path>
                </svg>
            </button>
        </div>
    );
}

export default WindowsAppControls;
